/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExternalCostDtoFromJSON, ExternalCostDtoToJSON, } from './ExternalCostDto';
import { MeseAnnoLightFromJSON, MeseAnnoLightToJSON, } from './MeseAnnoLight';
/**
 * Check if a given object implements the OtherCostListDto interface.
 */
export function instanceOfOtherCostListDto(value) {
    return true;
}
export function OtherCostListDtoFromJSON(json) {
    return OtherCostListDtoFromJSONTyped(json, false);
}
export function OtherCostListDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'otherCosts': json['otherCosts'] == null ? undefined : (json['otherCosts'].map(ExternalCostDtoFromJSON)),
        'monthWithCostsOrPlan': json['monthWithCostsOrPlan'] == null ? undefined : (json['monthWithCostsOrPlan'].map(MeseAnnoLightFromJSON)),
    };
}
export function OtherCostListDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'otherCosts': value['otherCosts'] == null ? undefined : (value['otherCosts'].map(ExternalCostDtoToJSON)),
        'monthWithCostsOrPlan': value['monthWithCostsOrPlan'] == null ? undefined : (value['monthWithCostsOrPlan'].map(MeseAnnoLightToJSON)),
    };
}
